import { render } from "./DiscountOrders.vue?vue&type=template&id=789b2860"
import script from "./DiscountOrders.vue?vue&type=script&lang=js"
export * from "./DiscountOrders.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ferlando/Desktop/Baboon/baboon-pos/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__